<script setup lang="ts">
import type { ComboboxEmptyProps } from "./combobox.types";
import { useComboboxEmpty } from "./useCombobox.Empty";

defineOptions({ name: "ComboboxEmpty" });

const props = withDefaults(defineProps<ComboboxEmptyProps>(), {
  message: "No results found.",
});

const { classes, isVisible } = useComboboxEmpty({ props });
</script>

<template>
  <div v-show="isVisible" part="base" :class="classes" class="e-combobox-empty" role="status" aria-live="polite">
    <slot>{{ message }}</slot>
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
